import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { environment } from "../../environments/environment";
import { map, catchError } from "rxjs/operators";
import * as CryptoJS from "crypto-js";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class BaseService {
  contentType: any;
  popularSeries = true;
  contentPopular = true;
  listStatus = true;
  genresData: boolean;
  option: any;
  opt: any;
  encryptedData: any;
  app_language: any;
  playerReady: any;
  modelData: any;
  position: any = {};
  backgroundImage: any;
  isShow = false;
  likeDislikeStatus: any;
  audioStatus: boolean = true;
  profile: any;
  changeprofile = false;
  constructor(private http: HttpClient, private router: Router) {
    this.updateToken();
  }
  updateToken(): void {
    this.app_language = JSON.parse(
      localStorage.getItem(environment.localStorageLangKey)
    );

    this.encryptedData = localStorage.getItem(environment.localStorageKey);
    if (this.encryptedData) {
      this.encryptedData = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );

      const headers = new HttpHeaders()
        .set("language", this.app_language)
        .set("Authorization", "Bearer " + this.encryptedData.token)
        .set("Content-Type", "application/x-www-form-urlencoded");
      this.opt = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.encryptedData.token,
        }),
        withCredentials: "include",
      };
      this.option = { headers };
    } else {
      const headers = new HttpHeaders()
        .set("language", this.app_language)
        .set("Content-Type", "application/x-www-form-urlencoded");

      this.option = { headers };
    }
  }

  categoryList(data: any): Observable<any> {
    this.updateToken();
    let api =
      environment.apiUrl +
      "category/listdata" +
      "?limit=" +
      data.limit +
      "&offset=" +
      data.offset;
    if (data.type) {
      api += "&type=" + data.type;
    }
    return this.http.get(api, this.option);
  }
  activation(code: any): Observable<any> {
    this.updateToken();
    const body = new HttpParams().set("login_code", code);
    return this.http
      .post(environment.apiUrl + "LoginTV", body, this.option)
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({
            status: error.status,
            message: error.error.message,
            datas: error.statusText,
          });
        })
      );
  }

  castCrewList(data: any): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiUrl +
        "cast-crew/" +
        data.name +
        "?limit=" +
        data.limit +
        "&offset=" +
        data.offset,
      this.option
    );
  }

  partnerList(data: any): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiUrl +
        "partnars" +
        "?limit=" +
        data.limit +
        "&offset=" +
        data.offset,
      this.option
    );
  }

  partnerDetail(data: any): Observable<any> {
    this.updateToken();
    return this.http.get(environment.apiUrl + "partnars", this.option);
  }
  popularContent(data: any): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiUrl +
        "contents/populars" +
        "?limit=" +
        data.limit +
        "&offset=" +
        data.offset,
      this.option
    );
  }
  popularCourses(data: any): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiUrl +
        "music/populars" +
        "?limit=" +
        data.limit +
        "&offset=" +
        data.offset,
      this.option
    );
  }
  trendingContentAudio(data: any): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiUrl +
        "contents/trending/audio" +
        "?limit=" +
        data.limit +
        "&offset=" +
        data.offset
    );
  }
  coockiesPolicyService(data): Observable<any> {
    this.updateToken();
    let api =
      environment.cookieUrl +
      "signed-cookie-policy?access_video_token=" +
      data.token +
      "&device_type=" +
      data.web;
    if (data.partner_id) {
      api += "&partner_id=" + data.partner_id;
    }
    if (data.type) {
      api += "&type=" + data.type;
    }
    return this.http
      .get(api, this.opt)
      .pipe(
        map((data: any) => {
          if (data.is_logout) {
            localStorage.removeItem(environment.localStorageKey);
            this.router.navigate(["/login"]);
          } else {
            return data;
          }
        })
      )
      .pipe(
        catchError((error) => {
          if (error.status == 401) {
            this.encryptedData.subscription_date = null;
            this.encryptedData.subscription_type = null;
            const app_promo = CryptoJS.AES.encrypt(
              JSON.stringify(this.encryptedData),
              environment.secretkey
            ).toString();
            localStorage.setItem(environment.localStorageKey, app_promo);
            this.router.navigate(["/subscription"]);
          }
          return throwError({ status: error.status, datas: error.error });
        })
      );
  }

  mostWatchvideosService(): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiUrl + "content/most-watch",
      this.option
    );
  }
  recomendationService(): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiUrl + "content/recommendation",
      this.option
    );
  }
  homeService(param): Observable<any> {
    this.updateToken();
    let api =
      environment.apiUrl +
      "featured/category/" +
      param.slug +
      "?limit=" +
      param.limit +
      "&offset=" +
      param.offset;
    if (param.partner_id) {
      api += "&partnar_id=" + param.partner_id;
    }
    return this.http.get(api, this.option);
  }
  categoryData(param: any): Observable<any> {
    this.updateToken();
    let api = environment.apiUrl + "categories?featured=" + param.feature;
    if (param.limit) {
      api +=
        "&limit=" +
        param.limit +
        "&offset=" +
        param.offset +
        "&banner=" +
        param.banner;
    }

    if (param.slug) {
      api += "&category=" + param.slug;
    }
    if (param.id) {
      api += "&partnar_id=" + param.id;
    }
    if (param.type) {
      if (param.type === "shows") {
        param.type = "series";
      }
      if (param.type === "videos") {
        param.type = "movies";
      }
      api += "&type=" + param.type;
    }
    return this.http.get(api, this.option);
  }
  moviesCategoriesData(param: any): Observable<any> {
    this.updateToken();
    let api =
      environment.apiUrl + "movies-categories?featured=" + param.feature;
    if (param.limit) {
      api +=
        "&limit=" +
        param.limit +
        "&offset=" +
        param.offset +
        "&banner=" +
        param.banner;
    }
    if (param.slug) {
      api += "&category=" + param.slug;
    }
    if (param.id) {
      api += "&partnar_id=" + param.id;
    }
    if (param.type) {
      if (param.type === "tv_shows") {
        param.type = "series";
      }
      if (param.type === "moviesData") {
        param.type = "movies";
      }
      api += "&type=" + param.type;
    }
    return this.http.get(api, this.option);
  }
  seriesCategoriesData(param: any): Observable<any> {
    this.updateToken();
    let api =
      environment.apiUrl + "series-categories?featured=" + param.feature;
    if (param.limit) {
      api +=
        "&limit=" +
        param.limit +
        "&offset=" +
        param.offset +
        "&banner=" +
        param.banner;
    }
    if (param.slug) {
      api += "&category=" + param.slug;
    }
    if (param.id) {
      api += "&partnar_id=" + param.id;
    }
    if (param.type) {
      if (param.type === "tv_shows") {
        param.type = "series";
      }
      api += "&type=" + param.type;
    }
    return this.http.get(api, this.option);
  }
  musicCategoriesData(param: any): Observable<any> {
    this.updateToken();
    let api = environment.apiUrl + "music-categories?featured=" + param.feature;
    if (param.limit) {
      api +=
        "&limit=" +
        param.limit +
        "&offset=" +
        param.offset +
        "&banner=" +
        param.banner;
    }
    if (param.slug) {
      api += "&category=" + param.slug;
    }
    if (param.id) {
      api += "&partnar_id=" + param.id;
    }
    if (param.type) {
      if (param.type === "tv_shows") {
        param.type = "series";
      }
      api += "&type=" + param.type;
    }
    return this.http.get(api, this.option);
  }

  musicDetail(data: any): Observable<any> {
    this.updateToken();
    let api = environment.apiUrl + "content/music-details/" + data.public_id;
    if (data.type) {
      api += "?type=" + data.type;
    }
    return this.http.get(api, this.option);
  }
  songDetail(data: any): Observable<any> {
    this.updateToken();
    let api =
      environment.apiUrl +
      "content/songs-detail/" +
      data.public_id +
      "?device_type=" +
      data.device_type;
    if (data.partner_id) {
      api += "&partner_id=" + data.partner_id;
    }
    if (data.type == "music") {
      api += "&album_id=" + data.album_id;
    } else if (data.type == "podcast") {
      api += "&podcast_id=" + data.album_id;
    }
    return this.http.get(api, this.option);
  }

  topSongsList(param: any): Observable<any> {
    this.updateToken();
    let api = environment.serverApiUrl + "content/top-music";
    if (param.limit) {
      api += "?limit=" + param.limit + "&offset=" + param.offset;
    }
    return this.http.get(api, this.option);
  }

  playList(param: any): Observable<any> {
    this.updateToken();
    let api = environment.apiUrl + "playlist";
    if (param.limit) {
      api += "?limit=" + param.limit + "&offset=" + param.offset;
    }
    return this.http.get(api, this.option);
  }
  createPlayList(data: any): Observable<any> {
    this.updateToken();
    const body = new HttpParams().set("name", data.name);
    return this.http.post(environment.apiUrl + "playlist", body, this.option);
  }
  addSongtoPlyalist(data: any): Observable<any> {
    this.updateToken();
    const body = new HttpParams()
      .set("playlist_id", data.playlist_id)
      .set("song_id", data.song_id);
    return this.http.post(
      environment.apiUrl + "playlist/song",
      body,
      this.option
    );
  }

  deletePlayList(data: any): Observable<any> {
    this.updateToken();
    return this.http.delete(
      environment.apiUrl + "playlist/delete/" + data.public_id,
      this.option
    );
  }
  playListDetail(param: any): Observable<any> {
    this.updateToken();
    let api = environment.apiUrl + "playlist/" + param;
    return this.http.get(api, this.option);
  }
  songdelete(data: any): Observable<any> {
    this.updateToken();
    let body: any = new HttpParams()
      .set("song_id", data.song_id)
      .set("playlist_id", data.playlist_id);
    let api = environment.apiUrl + "playlist/song?" + body;
    return this.http.delete(api, this.option);
  }
  watchvideosService(): Observable<any> {
    this.updateToken();
    return this.http.get(environment.apiUrl + "content/watching", this.option);
  }
  picOfYouService(): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiUrl + "content/picks-Ofyou",
      this.option
    );
  }
  usTvShowService(): Observable<any> {
    this.updateToken();
    return this.http.get(environment.apiUrl + "content/UsTv-show", this.option);
  }
  videoDetailService(id): Observable<any> {
    this.updateToken();
    let api = environment.apiUrl + "content/content-details?public_id=" + id;
    if (this.encryptedData?.profile_id) {
      api += "&profile_id=" + this.encryptedData.profile_id;
    }
    return this.http
      .get(api, this.option)
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          if (error.status == 401) {
            if (error.error.type === "heart_beat") {
              localStorage.clear();
              this.router.navigate(["/login"]);
            } else {
              this.encryptedData.subscription_date = null;
              this.encryptedData.subscription_type = null;
              const app_promo = CryptoJS.AES.encrypt(
                JSON.stringify(this.encryptedData),
                environment.secretkey
              ).toString();
              localStorage.setItem(environment.localStorageKey, app_promo);

              this.router.navigate(["/subscription"]);
            }
          }
          return throwError({
            status: error.status,
            datas: error.error,
            message: error.error.message,
          });
        })
      );
  }

  SeriesDetailService(id): Observable<any> {
    this.updateToken();
    return this.http
      .get(environment.apiUrl + "series/" + id, this.option)
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          if (error.status == 401) {
            if (error.error.type === "heart_beat") {
              localStorage.clear();
              this.router.navigate(["/login"]);
            } else {
              this.encryptedData.subscription_date = null;
              this.encryptedData.subscription_type = null;
              const app_promo = CryptoJS.AES.encrypt(
                JSON.stringify(this.encryptedData),
                environment.secretkey
              ).toString();
              localStorage.setItem(environment.localStorageKey, app_promo);
              this.router.navigate(["/subscription"]);
            }
          }
          return throwError({
            status: error.status,
            datas: error.statusText,
            message: error.error.message,
          });
        })
      );
  }

  relatedShowsService(id): Observable<any> {
    return this.http
      .get(
        environment.apiUrl + "content/related-movies?public_id=" + id,
        this.option
      )
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({ status: error.status, datas: error.statusText });
        })
      );
  }

  searchContent(data): Observable<any> {
    this.updateToken();
    if (!data.next_data) {
      data.next_data = "";
    }
    return this.http.get(
      environment.apiUrl +
        "content/search?search=" +
        data.search_data.trim() +
        "&next_data=" +
        data.next_data,
      this.option
    );
  }

  addFavorite(data): Observable<any> {
    const body = new HttpParams()
      .set("favorite_id", data.favorite_id)
      .set("type", data.type)
      .set("season_id", data.season_id ? data.season_id : "")
      .set("profile_id", this.encryptedData.profile_id);

    return this.http.post(environment.apiUrl + "favorites", body, this.option);
  }
  removeFavorite(id): Observable<any> {
    const body = new HttpParams().set("id", id);

    return this.http.delete(
      environment.apiUrl + "favorites?" + body,
      this.option
    );
  }
  addRemindMe(data): Observable<any> {
    const body = new HttpParams()
      .set("public_id", data.public_id)
      .set("content_type", data.content_type);
    return this.http.post(
      environment.apiUrl + "add-remindMe",
      body,
      this.option
    );
  }
  removeRemindMe(data): Observable<any> {
    const body = new HttpParams()
      .set("public_id", data.public_id)
      .set("content_type", data.content_type);
    return this.http.delete(
      environment.apiUrl + "remove-remindMe?" + body,
      this.option
    );
  }

  continueWatching(data): Observable<any> {
    this.updateToken();
    let api =
      environment.apiUrl +
      "content/continue-watching-list?device_type=" +
      data.device_type;
    if (this.encryptedData.profile_id) {
      api += "&profile_id=" + this.encryptedData.profile_id;
    }
    return this.http.get(api, this.option);
  }

  favoriteList(param): Observable<any> {
    this.updateToken();
    let api =
      environment.apiUrl +
      "favorites?limit=" +
      param.limit +
      "&offset=" +
      param.offset;

    if (param.type) {
      api += "&type=" + param.type;
    }
    if (this.encryptedData?.profile_id) {
      api += "&profile_id=" + this.encryptedData.profile_id;
    }
    return this.http.get(api, this.option);
  }

  suggetionService(data): Observable<any> {
    this.updateToken();
    let api = environment.apiBaseUrl + "search/text?search=" + data.search;
    if (data.type) {
      api += "&type=" + data.type;
    }
    return this.http.get(api, this.option);
  }

  addSuggation(data): Observable<any> {
    this.updateToken();
    const body = new HttpParams().set("text", data.text);
    return this.http.post(environment.apiUrl + "add/text", body, this.option);
  }

  removeSuggation(data): Observable<any> {
    this.updateToken();

    return this.http.delete(
      environment.apiUrl + "remove/text/" + data.id,
      this.option
    );
  }

  addComment(data): Observable<any> {
    this.updateToken();
    const body = new HttpParams()
      .set("rating_id", data.content_id)
      .set("rating", data.rating)
      .set("review", data.review)
      .set("type", data.type);
    return this.http.post(
      environment.apiBaseUrl + "ratingReviews",
      body,
      this.option
    );
  }
  likeDislike(data): Observable<any> {
    this.updateToken();
    let body: any;
    if (data.season_id) {
      body = new HttpParams()
        .set("like_id", data.like_id)
        .set("status", data.status)
        .set("type", data.type)
        .set("season_id", data.season_id)
        .set("profile_id", this.encryptedData.profile_id);
    } else {
      body = new HttpParams()
        .set("like_id", data.like_id)
        .set("status", data.status)
        .set("type", data.type)
        .set("profile_id", this.encryptedData.profile_id);
    }
    return this.http.post(environment.apiBaseUrl + "likeUnlike", body, this.option);
  }

  getComment(data): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiBaseUrl +
        "ratingReviews?rating_id=" +
        data.public_id +
        "&offset=" +
        data.offset +
        "&limit=" +
        data.limit +
        "&type=" +
        data.type,
      this.option
    );
  }

  genereDataService(data: any): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiBaseUrl + "genres?count=" + data,
      this.option
    );
  }
  genereLanguage(): Observable<any> {
    this.updateToken();
    return this.http.get(environment.apiUrl + "languages", this.option);
  }
  getDataByGenere(data): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiUrl +
        "genres/" +
        data.slug +
        "?offset=" +
        data.offset +
        "&limit=" +
        data.limit,
      this.option
    );
  }

  getDataBySubGenere(data): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiBaseUrl +
        "genres/" +
        data.slug +
        "/" +
        data.subslug +
        "?offset=" +
        data.offset +
        "&limit=" +
        data.limit,
      this.option
    );
  }

  getDataByLanguage(data): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiUrl +
        "languages/" +
        data.slug +
        "?offset=" +
        data.offset +
        "&limit=" +
        data.limit,
      this.option
    );
  }
  getDataByLanguageSluge(data): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiUrl +
        "languages/" +
        data.slug +
        "/" +
        data.subslug +
        "?offset=" +
        data.offset +
        "&limit=" +
        data.limit,
      this.option
    );
  }
  relatedSeriesService(id): Observable<any> {
    return this.http
      .get(
        environment.apiUrl + "content/related-shows?public_id=" + id,
        this.option
      )
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({ status: error.status, datas: error.statusText });
        })
      );
  }

  addContinueWatching(data): Observable<any> {
    this.updateToken();
    const body = new HttpParams()
      .set("content_id", data.contentId)
      .set("view_duration", data.viewDuration)
      .set("status", data.status)
      .set("device_type", data.device_type)
      .set("total_duration", data.totalDuration)
      .set("type", data.type)
      .set("profile_id", this.encryptedData.profile_id);

    return this.http
      .post(
        environment.apiUrl + "content/add-continue-watching",
        body,
        this.option
      )
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({ status: error.status, datas: error.statusText });
        })
      );
  }

  buyContent(data: any): Observable<any> {
    this.updateToken();
    const body = new HttpParams()
      .set("content_id", data.content_id)
      .set("transaction_id", data.transaction_id)
      .set("status", data.status)
      .set("content_type", data.content_type);

    return this.http.post(environment.apiUrl + "purchase", body, this.option);
  }
  accessvideoToken(data): Observable<any> {
    this.updateToken();
    const body = new HttpParams()
      .set("series_id", data.series_id)
      .set("episode_id", data.episode_id);
    return this.http.post(
      environment.apiUrl + "make-video-access-token",
      body,
      this.option
    );
  }
  addReport(data): Observable<any> {
    this.updateToken();
    const body = new HttpParams()
      .set("report_id", data.content_id)
      .set("description", data.description)
      .set("type", data.type)
      .set("title", data.title);
    return this.http.post(
      environment.apiBaseUrl + "reportAbuses",
      body,
      this.option
    );
  }

  recommended(param): Observable<any> {
    this.updateToken();
    const api = "";
    if (this.encryptedData?.profile_id) {
      const api = this.encryptedData.profile_id;
    }
    return this.http.get(
      environment.apiUrl +
        "content/recommended" +
        "?limit=" +
        param.limit +
        "&offset=" +
        param.offset +
        "&profile_id=" +
        api,
      this.option
    );
  }
  mostPopular(param): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiUrl +
        "content/mostPopular" +
        "?limit=" +
        param.limit +
        "&offset=" +
        param.offset,
      this.option
    );
  }
  logout(): Observable<any> {
    this.updateToken();
    const body = new HttpParams();
    return this.http.put(
      environment.apiUrl + "/auth/session-logout",
      body,
      this.option
    );
  }
  recommendedData(param): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiUrl +
        "featured/category/" +
        param.slug +
        "?limit=" +
        1 +
        "&offset=" +
        param.offset,
      this.option
    );
  }

  getrecommendedAllData(data): Observable<any> {
    this.updateToken();
    return this.http.get(
      environment.apiUrl +
        "content/related-movies?public_id=BUBuKLC&offset=" +
        data.offset +
        "&limit=" +
        data.limit,
      this.option
    );
  }
  playOn(position, data, type, unique_id) {
    var elmnt = document.getElementById(type + unique_id);
    this.position.width = elmnt.offsetWidth;
    this.modelData = undefined;
    this.playerReady = false;
    if (data.thumbnails.length > 0) {
      this.getBackgroundImage(data);
    }

    let layerX = position.layerX;
    if (layerX < 0) {
      layerX = position.offsetX;
    }

    if (data.source == "system") {
      setTimeout(() => {
        this.playerReady = true;
        this.modelData = data;
        this.contentType = type;
        this.position.left = position.pageX - layerX;
        if (position.pageY > 2400) {
          this.position.top = position.pageY - position.layerY - 80;
        } else {
          this.position.top = position.pageY - position.layerY;
        }
      }, 0);
    } else {
      this.modelData = undefined;
      this.playerReady = false;
    }
  }
  getBackgroundImage(data) {
    const img = data?.thumbnails.filter((val) => val.image_type == "banner");
    if (img?.length > 0) {
      this.backgroundImage = img[0].asset;
    } else {
      this.backgroundImage = environment.posterDefault;
    }
  }

  deleteContinueWatching(data) {
    let body: any;
    if (data === "clear_all") {
      body = new HttpParams().set("type", data);
    } else {
      body = new HttpParams().set("id", data);
    }
    this.updateToken();
    return this.http.post(
      environment.apiUrl + "content/delete-continue-watching",
      body,
      this.option
    );
  }
  logoutUser() {
    const body = new HttpParams();
    return this.http.put(
      environment.apiBaseUrl + "logout",
      body,
      this.option
    );
  }
}